import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Services/AuthContext";

type Role = "USER" | "CONTRIBUTOR" | "ADMIN" | "SUPERADMIN";

const rank: Record<Role, number> = {
  USER: 1,
  CONTRIBUTOR: 2,
  ADMIN: 3,
  SUPERADMIN: 4,
};

export function RequireRole({ minRole }: { minRole: Role }) {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null; 

  if (!isAuthenticated) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  const role = (user?.role ?? "USER") as Role;
  if (rank[role] < rank[minRole]) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
